<script setup lang="ts">
import { useI18n } from 'petite-vue-i18n';
import { TEXT } from '../../configs/text';
import Button from '../General/Button.vue';
import Heading from '../General/Heading.vue';
import Modal from '../General/Modal.vue';
import { ref } from 'vue';
import { useSignalRStore } from '../../stores';

const signalr = useSignalRStore()
const modalShow = ref<boolean>(false)

function handleEndClass() {
    modalShow.value = true
}

function handleEndClassConfirm() {
    signalr.endClassRoom()
    modalShow.value = false
}

const { t } = useI18n()
</script>

<template>
    <Button @click="handleEndClass" color="main" type="outline">
        <span>{{ t(TEXT.end_class) }}</span>
    </Button>
    <Modal v-model="modalShow">
        <Heading alignment="center">{{ t(TEXT.end_class) }}</Heading>
        <div class="text-center my-7" v-html="t(TEXT.end_class_desc)"></div>
        <Button color="warning" class="mx-auto" @click="handleEndClassConfirm">
            {{ t(TEXT.end) }}
        </Button>
    </Modal>
</template>